module.exports = __webpack_public_path__ + "img/film-threat-devices.7ce902c8.png";